import React, { useContext, useEffect, useState } from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

//import { UserContext } from "../../../../context/userContext"
import { CandidateContext } from '../../../../context/CandidateContext';
import { useSnackbar } from 'react-simple-snackbar'
import { API } from '../../../../http-common';
import { Spinner } from 'react-bootstrap';
import {GRUPO_EQ_COMERCIAL, ROLE_COMPLIANCE, ROLE_SOP_COMERCIAL, GROUP,PROSPECT_STATUS, SHOW_PROVIDER_RETRY } from "../../../../constants";
import { isEmptyValue, validateProspectDocuments, validateProspectAdministrativeInputs, buildProspectValidationList } from '../../../../helpers/validations';
import { UserContext } from '../../../../context/userContext';
import { BUSINESS, STATUS, THROTTLE_TIME_TEN_MINUTES, ROLE } from '../../../../helpers/constants';


const DOCUSIGN_STATUS = {
    sent: "Pendiente de firma",
    delivered: "Pendiente de firma",
    completed: "Firmado",
    declined: "Rechazado",
    voided: "Anulado"
}

const DOCUSIGN_ERRORS = {
    "ENVELOPE_DOES_NOT_EXIST": {
        title: "Error al consultar el contrato",
        message: "No se ha encontrado el contrato en DocuSign o no tiene permisos para acceder a él.",
        description: "Esto puede deberse a que el contrato aún no ha sido generado o ha sido eliminado de DocuSign."
    },
    "DEFAULT": {
        title: "Error al consultar el estado",
        message: "Ha ocurrido un error al consultar el estado del contrato en DocuSign.",
        description: "Por favor, intente nuevamente más tarde o contacte al administrador del sistema."
    }
}

export const ButtonsModal = ({ user_role, set_approve, set_pending, set_reject, is_balanz, set_other_area, checkBandkData, check_contract_data, loading_btn = false , resendMailProspect, voidDocuSignContract, updateDocuSignStatus, retryCreateProvider, closeModalsSignal}) => {

    const optionsError = {
        position: 'bottom-right',
        style: {
            backgroundColor: 'var(--bs-red)',
            border: '0',
            color: '#fff',
            fontSize: '20px',
            textAlign: 'center',
            marginBottom: '5rem',
        },
        closeStyle: {
            color: '#fff',
            fontSize: '16px',
            marginRight: '1rem',
        },
    }
    const optionsSuccess = {
        position: 'bottom-right',
        style: {
            backgroundColor: 'var(--bs-green)',
            border: '0',
            color: '#fff',
            fontSize: '20px',
            textAlign: 'center',
            marginBottom: '5rem',
        },
        closeStyle: {
            color: '#fff',
            fontSize: '16px',
            marginRight: '1rem',
        },
    }

    const [openSnackbarSuccess] = useSnackbar(optionsSuccess)
    const [openSnackbarError] = useSnackbar(optionsError)
    const [rejectMsg, setRejectMsg] = useState("")
    const [rejectMsg2, setRejectMsg2] = useState("")
    const [sendOtherAreaMsg, setSendOtherAreaMsg] = useState("")

    const [ApproveModalOpen, setApproveModalOpen] = useState(false);

    const [generateContractOpen, setGenerateContractOpen] = useState(false);
    const [openModalSendMail, setOpenModalSendMail] = useState(false)
    const [reactivateProcess, setReactivateProcess] = useState(false);
    const [ApproveModalPreIfa, setApproveModalPreIfa] = useState( false );
    const [ApproveModalPreIfa2, setApproveModalPreIfa2] = useState( false );
    const [isThrottled, setIsThrottled] = useState(false)

    const [getDataBankApi, setGetDataBankApi] = useState(true)

    const [RejectModalOpen, setRejectModalOpen] = useState(false);
    const [RejectModal2Open, setRejectModal2Open] = useState(false);
    const [sendOtherArea, setSendOtherArea] = useState(false);

    const [checkStatusModalOpen, setCheckStatusModalOpen] = useState(false);
    const [loadingStatus, setLoadingStatus] = useState(false);
    const [contractStatus, setContractStatus] = useState("");

    const [loadingAnular, setLoadingAnular] = useState(false);
    const [loadingActualizar, setLoadingActualizar] = useState(false);

    const [voidReason, setVoidReason] = useState("");
    const [confirmVoidModalOpen, setConfirmVoidModalOpen] = useState(false);
    const [voidReasonModalOpen, setVoidReasonModalOpen] = useState(false);
    const [confirmUpdateModalOpen, setConfirmUpdateModalOpen] = useState(false);

    const { userData } = useContext(UserContext)
    const { candidateData, knowingIfaValid, isSubUser } = useContext(CandidateContext)

    const [ ableToApprovePreIfa, setAbleToApprovePreIfa ] = useState(false)

    const [ working, setWorking ] = useState(false)

    const [ cliBalanz, setCliBalanz ] = useState(false)


    const setSeeAble = () => {
        const status = candidateData.prospect_status;
        const show = 'd-inline-block w-20';
        const none = 'd-none';
        let display_btn = "";
        if (status === PROSPECT_STATUS.EC_SOLO_BLZ ||
            status === PROSPECT_STATUS.EC_DESCARTADO_BLZ || 
            status === PROSPECT_STATUS.SC_DESCARTADO ) 
           { 
            display_btn = none;
            } 
        
        else if (GROUP.EQ_DIRECTORES.includes(user_role) && status > PROSPECT_STATUS.EC_DESCARTADO && status <= PROSPECT_STATUS.EC_SOLO_IFA) {
                display_btn = show
        } else if ( GROUP.EQ_SOPORTE.includes(user_role) && status > 29 && status <= PROSPECT_STATUS.SC_CANDIDATO || status === PROSPECT_STATUS.SC_BACK_CANDIDATO ) {
            display_btn = show
        } else if ( GROUP.COMPLIANCE.includes(user_role) && status > 39 && status === PROSPECT_STATUS.CMP_CANDIDATO || status === PROSPECT_STATUS.CMP_BACK_CANDIDATO ) {
            display_btn = show
        } else{
            display_btn = none
        }
        return display_btn
    }
  
    const handleClose = () => {
        setRejectMsg("");
        setRejectMsg2("");
        setSendOtherAreaMsg("");
        setRejectModalOpen(false);
        setRejectModal2Open(false);
        setSendOtherArea(false)
    }

    /* Al aprobar/rechazar un subusuario no se navega fuera de la página (a diferencia de un
    candidato principal), por lo que estos modales no se desmontan solos: hay que cerrarlos
    explícitamente cuando la acción se completa. */
    useEffect(() => {
        if (closeModalsSignal === undefined || closeModalsSignal === 0) return;

        handleClose();
        setApproveModalOpen(false);
        setApproveModalPreIfa(false);
        setApproveModalPreIfa2(false);
        setReactivateProcess(false);
        setGenerateContractOpen(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [closeModalsSignal])

    const scrollIntoViewTo = (id) => {
        if ( document.getElementById(id) ) {
            document.getElementById(id).scrollIntoView({ behavior: 'smooth' })
        } else if ( document.querySelector(`[for="${id}"]`) ) {
            document.querySelector(`[for="${id}"]`).scrollIntoView({ behavior: 'smooth' })
        }
    }

    const showSnackbarErrorValidations = (list_errors) => {
        openSnackbarError(
            <div>
                <b role="button" onClick={ () => scrollIntoViewTo('edit') } >
                    Complete los datos personales:
                </b>
                <br/>
                <div className='text-left'>
                    {list_errors.map((word) => {
                        return <span
                                role="button"
                                className='d-block me-2 mt-2'
                                key={word.id}
                                onClick={ () => scrollIntoViewTo(word.id) }
                                style={{'textAlign': 'left'}}
                            >
                            - {word.text} <br/>
                        </span>
                    })}
                </div>
            </div>
            ,[500000]
        )
    }

    const handleThrottledRetryCreateProvider = (id) => {
        if (isThrottled) {
            openSnackbarError("Se ha reintenado recientemente, espere 10 minutos y reintente");
            return;
        }

        setIsThrottled(true);
        retryCreateProvider(id)

        setTimeout(() => {
            setIsThrottled(false);
        }, THROTTLE_TIME_TEN_MINUTES);
    };



    const handleShowModalPreIfa = async (isent_balanz = false ) => {
        /* setApproveModalPreIfa( prev => ({ ...prev, status: true })
        setApproveModalPreIfa( prev => ({ ...prev, status: true }) */

        setWorking( true )

        if ( isent_balanz ) {
            setCliBalanz( true )
        }

        if( checkBandkData === false ) {
            openSnackbarError("faltan datos bancarios")
            setWorking( false )

        } else {
            let ableToApprove = await getProspectById(candidateData.id)

            if( ableToApprove === true ) {
                if ( isent_balanz ) {
                    setApproveModalPreIfa( true )
                } else {
                    setApproveModalPreIfa2( true )
                }

            }
        }
    }
    /* CONSULTAR LA DATA PERSONAL DEL CANDIDATO */
    const getProspectById = async (candidato_id) => {
        let ableToApprove = true;
        let remainingFields = [];

        const addError = (fieldKey) => {
            if (!remainingFields.includes(fieldKey)) {
                remainingFields.push(fieldKey);
            }

            ableToApprove = false;
        };

        try {
            const response = await API.get(`/prospects/${candidato_id}`);
            const data = response.data.data;

            const REQUIRED_FIELDS = [
                "address",
                "agente_cnv_aagi_ap",
                "business",
                "certificate_non_retention",
                "complete_name",
                "constancia_uif_so",
                "cuit",
                "date_birth",
                "document",
                "email",
                "enrollment_aagi",
                "gender",
                "income_tax_situation",
                "job_post",
                "lnaci",
                "location",
                "marital_status",
                "nationality",
                "occupation",
                "pep",
                "pep_reasons",
                "perception_agent",
                "phone_country_code",
                "phone_area",
                "phone_number",
                "phone2_country_code",
                "phone2_area",
                "phone2_number",
                "pos_front_iva",
                "pos_tax_profit",
                "province",
                "physical_person",
                "prospect_status",
                "regime_retention_income_tax",
                "registration_number",
                "suitable",
                "type_activity",
                "withholding_agent",
                "zip_code",
            ];

            REQUIRED_FIELDS.forEach((key) => {
                if (
                    (key === "registration_number" && data.registration_number === "") ||
                    (key === "agente_cnv_aagi_ap" && data.agente_cnv_aagi_ap === 1) ||
                    (key === "occupation" && data.business_id !== 2) ||
                    (key === "enrollment_aagi" && data.agente_cnv_aagi_ap === 1)
                ) {
                    return;
                }

                if (isEmptyValue(data[key])) {
                    addError(key);
                }
            });

            if (data.business_id === 2 && isEmptyValue(data.occupation)) {
                addError("occupation");
            }

            const documentErrors = validateProspectDocuments(data);
            const administrativeInputErrors = validateProspectAdministrativeInputs(data, { isSubUser });

            [...documentErrors, ...administrativeInputErrors].forEach(addError);

        } catch (error) {
            openSnackbarError("Error al obtener los datos del candidato");
            ableToApprove = false;
        }

        setWorking(false);

        if (!ableToApprove) {
            const list = buildProspectValidationList(remainingFields);
            showSnackbarErrorValidations(list);
        }

        return ableToApprove;
    };

    const fetchContractStatus = async () => {
        setLoadingStatus(true);
        try {
            console.log("Consultando estado del contrato para candidato ID:", candidateData.id);
            const response = await API.get(`/prospects/contracts/${candidateData.id}/docusign-status`);
            console.log("Respuesta recibida:", response.data);
            setContractStatus(response.data.status || "No disponible");
        } catch (error) {
            console.error("Error al obtener estado del contrato:", error);
            
            const errorCode = error.response?.data?.errorCode;
            if (errorCode && DOCUSIGN_ERRORS[errorCode]) {
                setContractStatus({
                    isError: true,
                    errorCode: errorCode,
                    ...DOCUSIGN_ERRORS[errorCode]
                });
            } else {
                // Error genérico
                setContractStatus({
                    isError: true,
                    errorCode: "DEFAULT",
                    ...DOCUSIGN_ERRORS["DEFAULT"]
                });
            }
        } finally {
            setLoadingStatus(false);
        }
    };

    const voidContract = async () => {
        setLoadingAnular(true);
        try {
            console.log("Anulando contrato para candidato ID:", candidateData.id);
            const success = await voidDocuSignContract(candidateData.id, voidReason.trim());
            if (success) {
                openSnackbarSuccess("Contrato anulado exitosamente");
                setCheckStatusModalOpen(false);
                setConfirmVoidModalOpen(false);
            }
        } catch (error) {
            console.error("Error al anular contrato:", error);
            openSnackbarError("Error al anular el contrato");
        } finally {
            setLoadingAnular(false);
            setVoidReason("");
        }
    };

    const updateStatus = async () => {
        setLoadingActualizar(true);
        try {
            console.log("Actualizando estado del contrato para candidato ID:", candidateData.id);
            const success = await updateDocuSignStatus(candidateData.id);
            if (success) {
                openSnackbarSuccess("Estado actualizado exitosamente");
                setCheckStatusModalOpen(false);
                setConfirmUpdateModalOpen(false);
            }
        } catch (error) {
            console.error("Error al actualizar estado:", error);
            openSnackbarError("Error al actualizar el estado");
        } finally {
            setLoadingActualizar(false);
        }
    };

    const checkData = () => {
        const err = []

        const requiereKyi = [...GROUP.EQ_DIRECTORES, ...GROUP.EQ_SOPORTE].includes(user_role)

        if (requiereKyi && candidateData.prospect_status >= 30 && !knowingIfaValid) {
            err.push("Conociendo mi IFA")
        }
        if (GROUP.EQ_SOPORTE.includes(user_role) && !check_contract_data) {
            err.push("Tipo de Contrato")
        }

        if (err.length > 0) {
            openSnackbarError(`Debe rellenar los datos: ${err.join(', ')}`)
            return
        }

        if (is_balanz < 1 && candidateData.prospect_status === 30) {
            openSnackbarError("El candidato debe ser Cliente Balanz")
            return
        }

        setApproveModalOpen(true)
    }

    const continuePsychoTech = () => {    
        setApproveModalOpen(true)
    }
  
    /* STATUS APROBAR */
    let nex_status_approved = 1;

     if (GROUP.EQ_SOPORTE.includes(user_role) && candidateData.prospect_status === PROSPECT_STATUS.SC_CANDIDATO) {
        //aprueba soporte comercial
        nex_status_approved = 50
    } else if(GROUP.EQ_SOPORTE.includes(user_role) && candidateData.prospect_status === PROSPECT_STATUS.SC_BACK_CANDIDATO){
        nex_status_approved = 51
    }
    else if (GROUP.EQ_DIRECTORES.includes(user_role)) {
        if(candidateData.prospect_status >= 30) {
            //aprobar ifa y pasa a soporte comercial
            nex_status_approved = 40
        }else {
            //aprobar pre candidato
            nex_status_approved = 30
        }
    }  else if (GROUP.COMPLIANCE.includes(user_role)) {
        if (candidateData.is_retro_fija) {
            // Si es retro fija, intenta pasarlo a flujo psicotécnico (backend confirma si aplica business_id y demás)
            nex_status_approved = STATUS.PENDIENTE_PSICO;
        } else {
            // En cualquier otro caso, aprueba compliance y va a generar contrato
            nex_status_approved = PROSPECT_STATUS.SC_APROBADO_COMPLIANCE
        }
    }

    // Si está en psicotécnico, va a aprobado compliance / generar contrato
    if (candidateData.prospect_status === STATUS.PENDIENTE_PSICO) {
        nex_status_approved = PROSPECT_STATUS.SC_APROBADO_COMPLIANCE
    }

    let reactivate = 0;

    if(candidateData.prospect_status === 39) {
        reactivate = 30
    } else if(candidateData.prospect_status === 49) {
        reactivate = 40
    }else if(candidateData.prospect_status === 59) {
        reactivate = 50
    } else {
        reactivate = 1
    }

    const handleVoidContractClick = () => {
        if (voidReason.trim() === "") {
            openSnackbarError("Por favor, ingresa un motivo para la anulación.");
            return; 
        }
        setConfirmVoidModalOpen(true);
    }

    return (
        <>
            <div className="row item d-flex flex-row flex-wrap justify-content-start pb-5" id="btns_modals">
                    <div className={ setSeeAble() } id="btn_aprobar_ifa">
                    <button
                        type="button"
                        style={{height: '59px' }}
                        className="w-100 btn green_btn balanz_btn"
                        aling="left"
                        onClick={ () => checkData() }
                    >
                        Aprobar
                    </button>
                </div>

                {
                [...GROUP.EQ_SOPORTE, ...GROUP.COMPLIANCE].includes(user_role) === true && (candidateData.prospect_status >= PROSPECT_STATUS.SC_CANDIDATO )&&
                <div className={setSeeAble("otra area")} id="btn_enviar_a">
                    <button type="button" className="w-100 btn gray_btn balanz_btn_long" onClick={() => setSendOtherArea(true)}>
                        {GROUP.COMPLIANCE.includes(user_role) ? (
                            <>Enviar a <br/>Soporte IFA</>
                        ) : (
                            <>Enviar a <br/>otra área</>
                        ) }
                        
                    </button>
                </div>
                }

                {/* // Aprobar en flujo Psicotecnico */}
                {
                user_role === ROLE.RRHH &&
                candidateData.prospect_status === STATUS.PENDIENTE_PSICO &&
                    <div className="d-inline-block w-20" id="btn_aprobar_ifa">
                    <button
                        type="button"
                        style={{height: '59px' }}
                        className="w-100 btn green_btn balanz_btn"
                        aling="left"
                        onClick={ () => continuePsychoTech() }
                    >
                        Continuar
                    </button>
                </div>
                }


                { candidateData.prospect_status < 100 &&
                        <div className={ setSeeAble() } id="btn_rechazar_ifa">
                            <button
                                type="button"
                                style={{height: '59px'}}
                                className="w-100 btn red_btn balanz_btn_long"
                                onClick={e => setRejectModalOpen(true)}
                            >
                                Rechazar
                            </button>
                        </div>
                }

                {/* BOTONES PRE IFA */}
                {(GROUP.EQ_DIRECTORES.includes(user_role) && candidateData.prospect_status <= 27) &&
                    <>
                        <div className="d-inline-block w-20 m-0" id="btn_pre_aprobar_ifa" style={{margin: "10px 10px"}}>
                            <button
                                className="w-100 btn green_btn balanz_btn_long"
                                aling="left"
                                onClick={ () => handleShowModalPreIfa() }
                            >
                                <small> Aprobar como<br/>Candidato IFA {is_balanz < 1 && "- Balanz"}</small>
                            </button>
                        </div>

                        {is_balanz === 0 &&
                            <div className="d-inline-block w-20 m-0" id="btn_pre_aprobar_ifa_2">
                                <button
                                    type="button"
                                    className="w-100 btn green_btn2 balanz_btn_long small"
                                    onClick={ () => handleShowModalPreIfa('isent_balanz') }
                                >
                                    <small style={{whiteSpace: 'nowrap'}}>Aprobar candidato IFA</small>
                                    <br/>
                                    <small style={{whiteSpace: 'nowrap'}}>sin ser cliente Balanz</small>
                                </button>
                            </div>
                        }
                        {is_balanz === 0 &&
                        <div className="d-inline-block w-20 m-0" id="btn_pre_rechazar_ifa_apro_balanz" style={{margin: "0 10px"}}>
                            <button
                            type="button"
                            className="w-100 text-white btn btn-secondary balanz_btn_long small"
                            onClick={() => setRejectModal2Open(true)}>

                                <small style={{whiteSpace: 'nowrap'}}>Rechazar como candidato</small>
                                <br/>
                                <small style={{whiteSpace: 'nowrap'}}>IFA / Aprobar Balanz</small>
                            </button>
                        </div>}
                        <div className="d-inline-block w-20 m-0" id="btn_pre_rechazar_todo">
                            <button
                            type="button"
                            className="w-100 btn red_btn balanz_btn_long small"
                            onClick={() => setRejectModalOpen(true)}>
                                Rechazar como
                                <br/>
                                <small style={{whiteSpace: 'nowrap'}}>candidato IFA {is_balanz < 1 && "- Balanz"} </small>
                            </button>
                        </div>

                    </>
                }

                {/* BOTON GENERAR CONTRATO */}
                {( GROUP.EQ_SOPORTE.includes(user_role) && candidateData.prospect_status === PROSPECT_STATUS.SC_APROBADO_COMPLIANCE) &&
                    <div className="d-inline-block w-23" id="btn_generar_contrato">
                        <button type="button" onClick={() => setGenerateContractOpen(true)} className="w-100 btn green_btn balanz_btn_long">
                            Generar <br/> {isSubUser ? "Documentos" : "Contrato"}
                         </button>
                    </div>
                }
                {/* // Permitir devolver para corregir */}
                {[...GROUP.EQ_SOPORTE].includes(user_role) && ([PROSPECT_STATUS.SC_APROBADO_COMPLIANCE, PROSPECT_STATUS.SC_CONTRATO_PENDIENTE].includes(candidateData.prospect_status) )&&
                    <div className="d-inline-block w-20" id="btn_enviar_a">
                        <button 
                            type="button"
                            style={{height: '59px'}}
                            className="w-100 btn gray_btn balanz_btn_long" 
                            onClick={() => setSendOtherArea(true)}>
                            Regresar a editar
                        </button>
                    </div>
                }

                {/* // Permitir descartar desde contrato */}
                {[...GROUP.EQ_SOPORTE].includes(user_role) && (candidateData.prospect_status === PROSPECT_STATUS.SC_APROBADO_COMPLIANCE )&&
                    <div className="d-inline-block w-20" id="btn_rechazar_ifa">
                        <button
                            type="button"
                            style={{height: '59px'}}
                            className="w-100 btn red_btn balanz_btn_long"
                            onClick={e => setRejectModalOpen(true)}>
                            Descartar
                        </button>
                    </div>
                }

                {/* BOTON REENVIO DE MAIL */}
                { (GROUP.EQ_SOPORTE.includes(user_role) && candidateData.prospect_status === 102 && !isSubUser) &&
                    <div className="d-inline-block w-23" id="btn_reenvio_mail">
                        <button type="button" onClick={() => setOpenModalSendMail(true)} className="w-100 btn green_btn2 balanz_btn_long">
                            Reenviar email 
                            <br/>
                            de Contrato
                        </button>
                    </div>
                }

                 { SHOW_PROVIDER_RETRY && (GROUP.EQ_SOPORTE.includes(user_role) && [200].includes(candidateData.prospect_status) && !candidateData.provider_id) &&
                    <div className="d-inline-block w-23" id="btn_reenvio_mail">
                        <button type="button" onClick={() => handleThrottledRetryCreateProvider(candidateData.id)} className="w-100 btn green_btn2 balanz_btn_long">
                            Reintentar crear 
                            <br/>
                            Proveedor
                        </button>
                    </div>
                }

                
                {GROUP.EQ_SOPORTE.includes(user_role) && [29,28,49,59].includes(candidateData.prospect_status) &&
                    <div className="d-inline-block w-23" id="btn_reactivate">
                        <button type="button" onClick={() => setReactivateProcess(true)} className="w-100 btn green_btn balanz_btn_long">
                            Reactivar <br/> Proceso
                        </button>
                    </div>
                }
              
                <div className='d-inline-block w-20' id="btn_aprobar_ifa">
                        <button
                            style={{height: '59px' }}
                            className="w-100 btn greenllow_btn balanz_btn_long"
                            aling="left"
                            onClick={ (e) => set_pending( candidateData.id ) }
                            >
                            Ver <br/>más tarde &nbsp;
                        </button>
                    </div>
                </div>

                { (GROUP.EQ_SOPORTE.includes(user_role) && candidateData.prospect_status === 102) &&
                    <>
                    <div className='row item d-flex flex-row flex-wrap justify-content-start pb-5'>
                        <h4 className='mb-3 h5'>Cambiar manualmente el status del contrato</h4>
                        
                        <div className="d-inline-block w-23" id="btn_contract_rejected">
                            <button 
                                type="button" 
                                onClick={() => {
                                    console.log("Abriendo modal de comprobación de estado");
                                    setCheckStatusModalOpen(true);
                                    fetchContractStatus();
                                }} 
                                className="w-100 btn blue_btn balanz_btn_long"
                            >
                                Comprobar
                                <br/>
                                Estado
                            </button>
                        </div>
                    </div>
                        
                    </>
                }

            {/* APROBAR MODAL */}
            <Modal isOpen={ApproveModalOpen} className="" id="to_approve">
                <ModalHeader className="justify-content-end">
                    <button className="close bg-transparent border-0" onClick={() => handleClose()} >
                        <span>&times;</span>
                    </button>
                </ModalHeader>
                <ModalBody className="modal-body">
                    <p className="modal_title green_text">
                        ¿Deseas aprobar al candidato para seguir con el proceso?
                        <span className="ms-2 name_applicant"><b> { candidateData.complete_name }</b></span>?
                    </p>
                    <p className="modal_text_info blue_title">
                        {/*<span>La información será enviada a Compilance para </span>*/}
                        {/*<span>Continuar el proceso.</span>*/}
                    </p>
                    <div className="row modal_btns">
                        <button
                            type="button"
                            className="btn blue_btn"
                            id="to_approve_email_confirm_btn"
                            onClick={ (e) => set_approve( candidateData.id, nex_status_approved, 'ec_avanzar' ) }
                        >
                            Confirmar
                        </button>
                        <button type="button" className="btn red_btn" id="to_approve_email_cancel_btn" onClick={e => setApproveModalOpen(false)}>
                            Cancelar
                        </button>
                    </div>
                </ModalBody>
            </Modal>
            {/* RECHAZAR MODAL */}
            <Modal isOpen={RejectModalOpen} className="" id="to_reject">
                <ModalHeader className="justify-content-end">
                    <button className="close bg-transparent border-0" onClick={e => handleClose()} >
                        <span>&times;</span>
                    </button>
                </ModalHeader>
                <ModalBody className="modal-body">
                    <p className="modal_title red_text">
                        ¿Quieres rechazar al postulante?:
                        <span className="name_applicant"> { candidateData.complete_name } </span>
                    </p>
                    <p className="modal_text_info blue_title">
                        Por favor, explica el motivo del rechazo:
                    </p>
                    <form action="#">
                        <textarea name="motivo" id="motivo" cols="30" rows="7" value={rejectMsg} onChange={ e => setRejectMsg(e.target.value) }></textarea>

                        <div className="row modal_btns">
                            <button type="button" className="btn blue_btn" id="to_reject_confirm_btn" onClick={() => set_reject(candidateData.id, rejectMsg, 29)}>
                                Confirmar
                            </button>
                            <button type="button" className="btn red_btn" id="to_reject_cancel_btn" onClick={e => handleClose()}>
                                Cancelar
                            </button>
                        </div>
                    </form>
                </ModalBody>
            </Modal>
            {/* ENVIAR A OTRA AREA MODAL */}
            <Modal isOpen={sendOtherArea} className="" id="to_reject">
                <ModalHeader className="justify-content-end">
                    <button className="close bg-transparent border-0" onClick={e => handleClose()} >
                        <span>&times;</span>
                    </button>
                </ModalHeader>
                <ModalBody className="modal-body">
                    <p className="modal_title">
                        Se enviara al postulante <span className="name_applicant"> { candidateData.complete_name } </span>
                         a {(GROUP.COMPLIANCE.includes(user_role) || [PROSPECT_STATUS.SC_APROBADO_COMPLIANCE, PROSPECT_STATUS.SC_CONTRATO_PENDIENTE].includes(candidateData?.prospect_status)) ? " Soporte Comercial" : "Equipo Comercial"}

                    </p>
                    {[PROSPECT_STATUS.SC_APROBADO_COMPLIANCE, PROSPECT_STATUS.SC_CONTRATO_PENDIENTE].includes(candidateData?.prospect_status) &&
                        <p className="modal_text_info blue_title"> Y deberá volver a realizar el flujo desde ese paso </p>}
                    <p className="modal_text_info blue_title">
                        Por favor, explica el motivo del cambio:
                    </p>
                    <form action="#">
                        <textarea name="motivo" id="motivo" cols="30" rows="7" value={sendOtherAreaMsg} onChange={ e => setSendOtherAreaMsg(e.target.value) }></textarea>

                        <div className="row modal_btns">
                            <button type="button" className="btn blue_btn" id="to_reject_confirm_btn" onClick={() =>
                                set_other_area(candidateData.id, sendOtherAreaMsg, ((GROUP.COMPLIANCE.includes(user_role) || [PROSPECT_STATUS.SC_APROBADO_COMPLIANCE, PROSPECT_STATUS.SC_CONTRATO_PENDIENTE].includes(candidateData?.prospect_status)) ? PROSPECT_STATUS.SC_CANDIDATO_REGRESADO : PROSPECT_STATUS.EC_IFA_Y_BLZ), 'sc_retrocede' )}>
                                Confirmar
                            </button>
                            <button type="button" className="btn red_btn" id="to_reject_cancel_btn" onClick={e => handleClose()}>
                                Cancelar
                            </button>
                        </div>
                    </form>
                </ModalBody>
            </Modal>

            {/* RECHAZAR IFA APROBAR BALANZ MODAL */}

            <Modal isOpen={RejectModal2Open} className="" id="to_reject">
                <ModalHeader className="justify-content-end">
                    <button className="close bg-transparent border-0" onClick={e => setRejectModal2Open(false)} >
                        <span>&times;</span>
                    </button>
                </ModalHeader>
                <ModalBody className="modal-body">
                    <p className="modal_title red_text">
                        ¿Quieres rechazar al postulante {<span className="name_applicant"> { candidateData.complete_name }, </span>} y sugerirle que sea cliente Balanz?


                    </p>
                    <p className="modal_text_info blue_title">
                        Por favor, explica el motivo del rechazo:
                    </p>
                    <form action="#">
                        <textarea name="motivo" id="motivo" cols="30" rows="7" value={rejectMsg2} onChange={ e => setRejectMsg2(e.target.value) }></textarea>

                        <div className="row modal_btns">
                            <button type="button" className="btn blue_btn" id="to_reject_confirm_btn" onClick={() => set_reject(candidateData.id, rejectMsg2, 28)}>
                                Confirmar
                            </button>
                            <button type="button" className="btn red_btn" id="to_reject_cancel_btn" onClick={e => handleClose()}>
                                Cancelar
                            </button>
                        </div>
                    </form>
                </ModalBody>
            </Modal>

            {/* Aprobar ifa balanz MODAL */}
            <Modal isOpen={ApproveModalPreIfa2} className="" id="to_approve">
                <ModalHeader className="justify-content-end">
                    <button className="close bg-transparent border-0" onClick={ () => setApproveModalPreIfa2( false )} >
                        <span>&times;</span>
                    </button>
                </ModalHeader>
                <ModalBody className={working === true ? 'hidden' : ''}>
                    <>
                        <p className="modal_title green_text">
                            ¿Aprobar al postulante:
                            <span className="ms-2 name_applicant"><b> { candidateData.complete_name }</b></span>?
                        </p>      
                        <div className="row modal_btns">
                            <button
                                type="button"
                                className="btn blue_btn"
                                id="to_approve_email_confirm_btn"
                                onClick={ () => set_approve( candidateData.id, 30, 'sc_avanza') }
                            >
                                Confirmar
                            </button>
                            <button type="button" className="btn red_btn" onClick={ () => setApproveModalPreIfa2( false )} >
                                Cancelar
                            </button>
                        </div>
                    </>
                </ModalBody>
            </Modal>

            {/* Aprobar pre candidato ifa sin ser balanz MODAL */}
            <Modal isOpen={ApproveModalPreIfa} className="" id="to_approve">
                <ModalHeader className="justify-content-end">
                    <button className="close bg-transparent border-0" onClick={ () => setApproveModalPreIfa( false )} >
                        <span>&times;</span>
                    </button>
                </ModalHeader>
                <ModalBody className={working === true ? 'hidden' : ''}>
                    <>
                        <p className="modal_title green_text">
                            ¿Aprobar al postulante:
                            <span className="ms-2 name_applicant"><b> { candidateData.complete_name }</b></span>?
                            {is_balanz < 1 &&
                                <b className="d-block fw-bold text-danger">¿Sin ser cliente Balanz?</b>
                            }
                        </p>  
                        <div className="row modal_btns">
                            <button
                                type="button"
                                className="btn blue_btn"
                                id="to_approve_email_confirm_btn"
                                onClick={ () => set_approve( candidateData.id, 31, 'sc_avanza') }
                            >
                                Confirmar
                            </button>
                            <button type="button" className="btn red_btn" onClick={ () => setApproveModalPreIfa( false )} >
                                Cancelar
                            </button>
                        </div>
                    </>
                </ModalBody>
            </Modal>

             {/* Reactivar Proceso */}
             <Modal isOpen={reactivateProcess} className="" id="to_approve">
                <ModalHeader className="justify-content-end">
                    <button className="close bg-transparent border-0" onClick={ () => setReactivateProcess( false )} >
                        <span>&times;</span>
                    </button>
                </ModalHeader>
                <ModalBody className={working === true ? 'hidden' : ''}>
                    <>
                        <p className="modal_title green_text">
                            ¿Esta Seguro que desea reanudar el proceso del candidato:
                            <span className="ms-2 name_applicant"><b> { candidateData.complete_name }</b></span>?
                        </p>

                        <div className="row modal_btns">
                            <button
                                type="button"
                                className="btn blue_btn"
                                id="to_approve_email_confirm_btn"
                                onClick={ () => set_approve( candidateData.id, reactivate ) }
                            >
                                Confirmar
                            </button>
                            <button type="button" className="btn red_btn" onClick={ () => setReactivateProcess( false )} >
                                Cancelar
                            </button>
                        </div>
                    </>
                </ModalBody>
            </Modal>

            {/* GENERAR CONTRATO MODAL */}
            <Modal isOpen={generateContractOpen} className="" id="to_approve">
                <ModalHeader className="justify-content-end">
                    <button className="close bg-transparent border-0" onClick={ () => setGenerateContractOpen( false )} >
                        <span>&times;</span>
                    </button>
                </ModalHeader>
                <ModalBody className={working === true ? 'hidden' : ''}>
                    <>
                        <p className="modal_title green_text">
                            ¿Está seguro de que quiere generar {isSubUser ? "los documentos" : "y enviar el contrato"} a
                            <span className="ms-2 name_applicant"><b> { candidateData.complete_name }</b></span>?
                        </p>

                        <div className="row modal_btns">
                            <button
                                type="button"
                                className="btn blue_btn"
                                id="to_approve_email_confirm_btn"
                                disabled={loading_btn}
                                onClick={ () => set_approve( candidateData.id, 102 ) }
                            >
                                {loading_btn ? (
                                    <>
                                        <div className="d-flex align-items-center justify-content-center">
                                            <Spinner style={{ 'margin-right': '5px' }} size="sm" animation="border" />
                                            <span>Enviando...</span>
                                        </div>

                                    </>
                                ) : 'Confirmar'}
                            </button>
                            <button type="button" disabled={loading_btn} className="btn red_btn" onClick={ () => setGenerateContractOpen( false )} >
                                Cancelar
                            </button>
                        </div>
                    </>
                </ModalBody>
            </Modal>

            {/* Modal para reenvio de mails */}
            <Modal isOpen={openModalSendMail} className="" id="to_approve">
                <ModalHeader className="justify-content-end">
                    <button className="close bg-transparent border-0" onClick={ () => setOpenModalSendMail(false)} >
                        <span>&times;</span>
                    </button>
                </ModalHeader>
                <ModalBody className={working === true ? 'hidden' : ''}>
                    <>
                        <p className="modal_title green_text">
                            ¿Deseas reenviar  mail del contrato a
                            <span className="ms-2 name_applicant"><b> { candidateData.complete_name }</b></span>?
                        </p>

                        <div className="row modal_btns">
                            <button
                                type="button"
                                className="btn blue_btn"
                                id="to_approve_email_confirm_btn"
                                disabled={loading_btn}
                                onClick={ () => resendMailProspect( candidateData.id,setOpenModalSendMail) }
                            > {loading_btn ? (
                                <>
                                    <div className="d-flex align-items-center justify-content-center">
                                        <Spinner style={{ 'margin-right': '5px' }} size="sm" animation="border" />
                                        <span>Enviando...</span>
                                    </div>

                                </>
                            ) : 'Confirmar'}
                        </button>
                        <button type="button" disabled={loading_btn} className="btn red_btn" onClick={ () => setOpenModalSendMail(false)} >
                            Cancelar
                        </button>
                        </div>
                    </>
                </ModalBody>

            </Modal>

            {/* Modal para comprobar estado */}
            <Modal isOpen={checkStatusModalOpen} className="" id="check_status">
                <ModalHeader className="justify-content-end">
                    <button 
                        className="close bg-transparent border-0 d-flex align-items-center" 
                        onClick={() => {
                            setCheckStatusModalOpen(false);
                            setVoidReason("");
                        }}
                        disabled={loadingStatus || loadingAnular || loadingActualizar}
                        style={{ color: '#000', fontSize: '16px', fontWeight: 'bold' }}
                    >
                        <span className="me-2">Cerrar</span> <span style={{ fontSize: '24px' }}>&times;</span>
                    </button>
                </ModalHeader>
                <ModalBody>
                    {loadingStatus ? (
                        <div className="d-flex justify-content-center align-items-center flex-column" style={{ height: '200px' }}>
                            <p className="modal_title">Estado del contrato en DocuSign: <b>Comprobando...</b></p>
                            <Spinner animation="border" role="status" style={{ width: '3rem', height: '3rem' }}>
                                <span className="visually-hidden">Cargando...</span>
                            </Spinner>
                        </div>
                    ) : typeof contractStatus === 'object' && contractStatus.isError ? (
                        <div className="text-center">
                            <p className="modal_title text-danger">
                                <i className="fas fa-exclamation-triangle me-2"></i>
                                {contractStatus.title}
                            </p>
                            <div className="alert alert-danger">
                                {contractStatus.message}
                            </div>
                            <p className="modal_text_info">
                                {contractStatus.description}
                            </p>
                            <div className="row justify-content-center modal_btns">
                                <button 
                                    type="button" 
                                    className="btn blue_btn" 
                                    onClick={() => setCheckStatusModalOpen(false)}
                                >
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    ) : (
                        <>
                            <p className="modal_title">
                                Estado del contrato en DocuSign: <b>{DOCUSIGN_STATUS[contractStatus]}</b>
                            </p>
                            
                            {["sent", "delivered"].includes(contractStatus) ? (
                                <>
                                    <p className="modal_text_info"> 
                                        En caso de querer anular el contrato que se encuentra pendiente de firma, hacer click en "Anular"
                                    </p>
                                </>
                            ) : (
                                <p className="modal_text_info">
                                    El estado en la plataforma IFA/PE no está actualizado/sincronizado con Docusign. Haga click en "Actualizar" para que se guarde el nuevo estatus en la plataforma IFA/PE.
                                </p>
                            )}
                            
                            <div className="row modal_btns">
                                {["sent", "delivered"].includes(contractStatus) ? (
                                    <>
                                        <button 
                                            type="button" 
                                            className="btn red_btn" 
                                            disabled={loadingAnular}
                                            onClick={() => {
                                                setCheckStatusModalOpen(false);
                                                setVoidReasonModalOpen(true);
                                            }}
                                        >
                                            {loadingAnular ? (
                                                <>
                                                    <div className="d-flex align-items-center justify-content-center">
                                                        <Spinner style={{ 'margin-right': '5px' }} size="sm" animation="border" />
                                                        <span>Anulando...</span>
                                                    </div>
                                                </>
                                            ) : 'Anular'}
                                        </button>
                                    </>
                                ) : (
                                    <button 
                                        type="button" 
                                        className="btn blue_btn" 
                                        disabled={loadingActualizar}
                                        onClick={() => {
                                            setCheckStatusModalOpen(false);
                                            setConfirmUpdateModalOpen(true);
                                        }}
                                    >
                                        {loadingActualizar ? (
                                            <>
                                                <div className="d-flex align-items-center justify-content-center">
                                                    <Spinner style={{ 'margin-right': '5px' }} size="sm" animation="border" />
                                                    <span>Actualizando...</span>
                                                </div>
                                            </>
                                        ) : 'Actualizar'}
                                    </button>
                                )}
                            </div>
                        </>
                    )}
                </ModalBody>
            </Modal>

            {/* Modal para ingresar motivo de anulación */}
            <Modal isOpen={voidReasonModalOpen} className="" id="void_reason">
                <ModalHeader className="justify-content-end">
                    <button 
                        className="close bg-transparent border-0 d-flex align-items-center" 
                        onClick={() => {
                            setVoidReasonModalOpen(false);
                            setVoidReason("");
                        }} 
                        disabled={loadingAnular}
                        style={{ color: '#000', fontSize: '16px', fontWeight: 'bold' }}
                    >
                        <span className="me-2">Cerrar</span> <span style={{ fontSize: '24px' }}>&times;</span>
                    </button>
                </ModalHeader>
                <ModalBody>
                    <p className="modal_title red_text">
                        Motivo de anulación de contrato
                    </p>
                    <p className="modal_text_info blue_title mb-1">
                        Por favor, ingresa el motivo de la anulación:
                    </p>
                    <textarea 
                        name="voidReason" 
                        id="voidReason" 
                        className='form-control'
                        rows="4" 
                        value={voidReason} 
                        onChange={ e => setVoidReason(e.target.value) }>
                    </textarea>
                    
                    <div className="row modal_btns mt-3">
                        <button 
                            type="button" 
                            className="btn blue_btn" 
                            disabled={loadingAnular}
                            onClick={() => {
                                if (voidReason.trim() === "") {
                                    openSnackbarError("Por favor, ingresa un motivo para la anulación.");
                                    return;
                                }
                                setVoidReasonModalOpen(false);
                                setConfirmVoidModalOpen(true);
                            }}
                        >
                            Continuar
                        </button>
                        <button 
                            type="button" 
                            className="btn red_btn" 
                            disabled={loadingAnular}
                            onClick={() => {
                                setVoidReasonModalOpen(false);
                                setVoidReason("");
                            }}
                        >
                            Cancelar
                        </button>
                    </div>
                </ModalBody>
            </Modal>

            {/* Nuevo Modal para confirmación de anulación */}
            <Modal isOpen={confirmVoidModalOpen} className="" id="confirm_void">
                <ModalHeader className="justify-content-end">
                    <button 
                        className="close bg-transparent border-0 d-flex align-items-center" 
                        onClick={() => setConfirmVoidModalOpen(false)} 
                        disabled={loadingAnular}
                        style={{ color: '#000', fontSize: '16px', fontWeight: 'bold' }}
                    >
                        <span className="me-2">Cerrar</span> <span style={{ fontSize: '24px' }}>&times;</span>
                    </button>
                </ModalHeader>
                <ModalBody>
                    <p className="modal_title red_text">
                        Confirmar anulación de contrato
                    </p>
                    <p className="modal_text_info">
                        Usted está a punto de anular el contrato en Docusign. Esto significa que el prospect no lo podrá visualizar ni firmar en dicha plataforma a partir de esta anulación. El motivo por el que usted anula el contrato quedará registrado tanto en el historial de esta plataforma como en el historial de Docusign.
                    </p>
                    <div className="row modal_btns">
                        <button 
                            type="button" 
                            className="btn blue_btn" 
                            disabled={loadingAnular}
                            onClick={() => {
                                voidContract();
                                // Se eliminó la línea setConfirmVoidModalOpen(false) para que no cierre inmediatamente
                            }}
                        >
                            {loadingAnular ? (
                                <>
                                    <div className="d-flex align-items-center justify-content-center">
                                        <Spinner style={{ 'margin-right': '5px' }} size="sm" animation="border" />
                                        <span>Anulando...</span>
                                    </div>
                                </>
                            ) : 'Aceptar'}
                        </button>
                        <button 
                            type="button" 
                            className="btn red_btn" 
                            disabled={loadingAnular}
                            onClick={() => setConfirmVoidModalOpen(false)}
                        >
                            Cancelar
                        </button>
                    </div>
                </ModalBody>
            </Modal>

            {/* Modal para confirmación de actualización */}
            <Modal isOpen={confirmUpdateModalOpen} className="" id="confirm_update">
                <ModalHeader className="justify-content-end">
                    <button 
                        className="close bg-transparent border-0 d-flex align-items-center" 
                        onClick={() => setConfirmUpdateModalOpen(false)} 
                        disabled={loadingActualizar}
                        style={{ color: '#000', fontSize: '16px', fontWeight: 'bold' }}
                    >
                        <span className="me-2">Cerrar</span> <span style={{ fontSize: '24px' }}>&times;</span>
                    </button>
                </ModalHeader>
                <ModalBody>
                    <p className="modal_title">
                        Confirmar actualización de estado
                    </p>
                    <p className="modal_text_info">
                        Usted está a punto de sincronizar el estado del contrato en la plataforma de IFA/PE de acuerdo a la información que figura en el estado de este contrato en Docusign.
                    </p>
                    <div className="row modal_btns">
                        <button 
                            type="button" 
                            className="btn blue_btn" 
                            disabled={loadingActualizar}
                            onClick={() => updateStatus()}
                        >
                            {loadingActualizar ? (
                                <>
                                    <div className="d-flex align-items-center justify-content-center">
                                        <Spinner style={{ 'margin-right': '5px' }} size="sm" animation="border" />
                                        <span>Actualizando...</span>
                                    </div>
                                </>
                            ) : 'Aceptar'}
                        </button>
                        <button 
                            type="button" 
                            className="btn red_btn" 
                            disabled={loadingActualizar}
                            onClick={() => setConfirmUpdateModalOpen(false)}
                        >
                            Cancelar
                        </button>
                    </div>
                </ModalBody>
            </Modal>
        </>
    )
}